import RpcService             from "@/core/services/Rpc/RpcService";
import type RpcResponse         from "@/core/services/Rpc/RpcResponse";

import type TransportDowntime from '@/domains/TransportDowntime/TransportDowntime';

class TransportDowntimesDAO {

    /** Загружает список простоев */
    static async getList(
      filters?: {
        id?: number,
        transportOrder?: { id: number }
      }
    ): Promise<RpcResponse> {
        return await RpcService.makeRequest(
          'transportDowntimes.getList',
          {
            ...filters,
            transportOrder: filters?.transportOrder ? { id: filters.transportOrder.id } : undefined,
          }
        );
    }

    /** Создаёт или обновляет простой */
    static async upsert(transportDowntime: TransportDowntime): Promise<RpcResponse> {
        return await RpcService.makeRequest('transportDowntimes.upsert', {
            transportDowntime,
        });
    }

    /** Удаляет простой по ID */
    static async delete(id: number): Promise<RpcResponse> {
        return await RpcService.makeRequest('transportDowntimes.delete', { id });
    }
}

export default TransportDowntimesDAO;
